import React from 'react';
import Icon from 'components/AppIcon';
import { NOTIFICATION_CATEGORIES } from './notificationsData';

export default function FilterBar({
  activeCategory,
  onCategoryChange,
  statusFilter,
  onStatusChange,
  priorityFilter,
  onPriorityChange,
  dateRange,
  onDateRangeChange,
  searchQuery,
  onSearchChange,
  categoryCounts,
}) {
  const statusOptions = ['All', 'Unread', 'Read'];
  const priorityOptions = ['All', 'High', 'Medium', 'Low'];
  const dateOptions = [
    { value: '7', label: 'Last 7 days' },
    { value: '30', label: 'Last 30 days' },
    { value: '90', label: 'Last 90 days' },
    { value: 'all', label: 'All time' },
  ];

  return (
    <div className="bg-card border border-border rounded-xl overflow-hidden">
      {/* Category tabs */}
      <div className="flex items-center gap-1 px-4 pt-4 pb-3 overflow-x-auto scrollbar-hide border-b border-border">
        {NOTIFICATION_CATEGORIES?.map((cat) => {
          const count = categoryCounts?.[cat?.id] ?? 0;
          const isActive = activeCategory === cat?.id;
          return (
            <button
              key={cat?.id}
              onClick={() => onCategoryChange(cat?.id)}
              className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-150 ${
                isActive
                  ? 'bg-primary text-white shadow-sm'
                  : 'text-muted-foreground hover:bg-muted hover:text-foreground'
              }`}
            >
              <Icon name={cat?.icon} size={13} />
              {cat?.label}
              {count > 0 && (
                <span
                  className={`inline-flex items-center justify-center min-w-5 h-5 px-1.5 rounded-full text-xs font-semibold ${
                    isActive ? 'bg-white text-primary' : 'bg-muted text-muted-foreground'
                  }`}
                >
                  {count}
                </span>
              )}
            </button>
          );
        })}
      </div>
      {/* Secondary filters */}
      <div className="flex items-center gap-3 px-4 py-3 flex-wrap">
        {/* Status */}
        <div className="flex items-center gap-1 bg-muted rounded-lg p-1">
          {statusOptions?.map((opt) => (
            <button
              key={opt}
              onClick={() => onStatusChange(opt)}
              className={`px-3 py-1 rounded-md text-xs font-medium transition-all ${
                statusFilter === opt ? 'bg-card text-foreground shadow-sm' : 'text-muted-foreground hover:text-foreground'
              }`}
            >
              {opt}
            </button>
          ))}
        </div>

        {/* Priority */}
        <div className="flex items-center gap-1 bg-muted rounded-lg p-1">
          {priorityOptions?.map((opt) => (
            <button
              key={opt}
              onClick={() => onPriorityChange(opt)}
              className={`px-3 py-1 rounded-md text-xs font-medium transition-all ${
                priorityFilter === opt ? 'bg-card text-foreground shadow-sm' : 'text-muted-foreground hover:text-foreground'
              }`}
            >
              {opt}
            </button>
          ))}
        </div>

        {/* Date range */}
        <select
          value={dateRange}
          onChange={(e) => onDateRangeChange(e?.target?.value)}
          className="px-3 py-1.5 text-xs font-medium text-foreground bg-muted border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/20 cursor-pointer"
        >
          {dateOptions?.map((opt) => (
            <option key={opt?.value} value={opt?.value}>{opt?.label}</option>
          ))}
        </select>

        {/* Search */}
        <div className="relative ml-auto">
          <Icon name="Search" size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <input
            type="text"
            placeholder="Search notifications…"
            value={searchQuery}
            onChange={(e) => onSearchChange(e?.target?.value)}
            className="pl-8 pr-3 py-1.5 text-xs text-foreground bg-muted border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/20 w-52"
          />
          {searchQuery && (
            <button
              onClick={() => onSearchChange('')}
              className="absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
            >
              <Icon name="X" size={12} />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
